import React from 'react';
import { useRange, UseRangeProps } from 'react-instantsearch';

export const VirtualRange: React.FC<UseRangeProps> = (props) => {
    useRange(props);

    return null;
};
